import { Key } from 'w3c-keys';
export const AG_GRID_COL_ID = 'col-id';
export const AG_GRID_HEADER = 'ag-header-cell';
export const addListenerToHeaderCells = (parentElement, handleChange) => {
    const keyPressListener = (event) => {
        var _a;
        if (event.key === Key.Enter) {
            const activeElement = document.activeElement;
            if (parentElement && activeElement) {
                if (parentElement.getAttribute(AG_GRID_COL_ID) ===
                    activeElement.getAttribute(AG_GRID_COL_ID) &&
                    ((_a = activeElement.className) === null || _a === void 0 ? void 0 : _a.includes(AG_GRID_HEADER))) {
                    handleChange(event);
                }
            }
        }
    };
    parentElement === null || parentElement === void 0 ? void 0 : parentElement.addEventListener('keydown', keyPressListener);
    return () => {
        parentElement === null || parentElement === void 0 ? void 0 : parentElement.removeEventListener('keydown', keyPressListener);
    };
};
//# sourceMappingURL=column-header-util.js.map